import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IOdbBillCoverResponse } from '@dch/billing-business-logic';
import { EntityManager } from '@dch/entity-manager';
import { of } from 'rxjs';
import { map, catchError, withLatestFrom, mergeMap } from 'rxjs/operators';
import { BILLING_COVER_ENTITY } from 'src/app/my-bill/config/my-bill-entity.config';
import {
  getBillingCoverFailure,
  getBillingCoverRequest,
  getBillingCoverSuccess,
} from '../actions/billing-cover.actions';
import { ApplicationState } from '../reducers';
import { selectCustomer } from '../selectors/customer-account.selector';

@Injectable()
export class BillingCoverEffects {
  getBillCover$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getBillingCoverRequest),
      withLatestFrom(this.store.select(selectCustomer)),
      mergeMap(([{ billingAccountNumber, reference }, customer]) =>
        EntityManager.getEntity<IOdbBillCoverResponse>(BILLING_COVER_ENTITY, {
          cdbId: customer.customerId,
          billingAccountNumber,
          reference,
        }).pipe(
          map((entity) =>
            entity.value
              ? getBillingCoverSuccess({
                  data: entity.value,
                  billingAccountNumber,
                  reference,
                })
              : getBillingCoverFailure({ billingAccountNumber, reference })
          ),
          catchError(() =>
            of(getBillingCoverFailure({ billingAccountNumber, reference }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<ApplicationState>
  ) {}
}
